import { render, staticRenderFns } from "./ltjl.vue?vue&type=template&id=67c4a2b2&scoped=true&"
import script from "./ltjl.vue?vue&type=script&lang=js&"
export * from "./ltjl.vue?vue&type=script&lang=js&"
import style0 from "./ltjl.vue?vue&type=style&index=0&id=67c4a2b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c4a2b2",
  null
  
)

export default component.exports